/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React, { useState } from 'react';
import { View, ViewStyle } from 'react-native';
import ChipGroupView from '@airasia-phoenix/react-native/components/ChipGroupView';
import { MemoizedListViewProps } from '@airasia-phoenix/react-native/components/SearchableListPageView/MemoizedListView';
import type { Suggestions } from '../../types';

interface PopularSearchesSectionProps {
  item: Suggestions[];
  onSelect: (selectedItems?: MemoizedListViewProps[]) => void;
  styles: {
    popularSearchesContainer: ViewStyle;
  };
  orientation: {
    columns: number;
    rows: number;
    horizontalSpacing: number;
    verticalSpacing: number;
  };
}

export const PopularSearchesSection: React.FC<PopularSearchesSectionProps> = ({
  item,
  onSelect,
  styles,
  orientation,
}) => {
  const [resetKey, setResetKey] = useState(0);

  const chips = item.map((suggest) => ({
    text: suggest.name,
    isSelected: false,
    disabled: false,
  }));

  return (
    <View style={styles.popularSearchesContainer}>
      <ChipGroupView
        key={`chip-group-${resetKey}`}
        chipViewProps={chips}
        orientation={orientation}
        onChange={(updatedChips) => {
          const clickedIndex = updatedChips.findIndex((c) => c.isSelected);
          if (clickedIndex !== -1) {
            const selectedSuggest = item[clickedIndex];
            onSelect([
              {
                model: {
                  place: selectedSuggest,
                  trackingSource: 'popular_searches',
                  trackingIndex: clickedIndex + 1,
                },
              } as unknown as MemoizedListViewProps,
            ]);
            setResetKey((prev) => prev + 1);
          }
        }}
      />
    </View>
  );
};
